import * as React from "react";

import styles from "./SegmentedControl.module.css";

export interface SegmentedOption {
  key: string;
  label: React.ReactNode;
  icon?: string;
}

export interface SegmentedControlProps {
  options: SegmentedOption[];
  value: string;
  onChange: (key: string) => void;
  className?: string;
}

/** iOS-style segmented control (EDO toggle, mobile card tabs). */
export const SegmentedControl: React.FC<SegmentedControlProps> = ({ options, value, onChange, className }) => (
  <div
    className={`${styles.root}${className ? ` ${className}` : ``}`}
    style={{ gridTemplateColumns: `repeat(${options.length}, 1fr)` }}
  >
    {options.map((o) => {
      const active = o.key === value;
      return (
        <span
          key={o.key}
          onClick={() => onChange(o.key)}
          className={`${styles.segment}${active ? ` ${styles.active}` : ``}`}
        >
          {o.icon && <i className={o.icon} />}
          {o.label}
        </span>
      );
    })}
  </div>
);
